import { useQuery } from '@tanstack/react-query'
import { CameraType } from 'models/IFrameInfo'
import CameraApiService from 'services/cameraApiServices'

type CameraListProps = {
	type: CameraType
}

export const useGetCameraList = (props: CameraListProps) => {
	const { data, refetch, isError, isLoading } = useQuery({
		queryKey: ['cameraList'],
		queryFn: async () => {
			return await CameraApiService.getCameraList(props.type)
		},
		staleTime: 50000,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
